
import { secureStorage, StorageKeys } from "@services/secureStorage.service";
import { baseApi } from "@store/apis";

import type { Badge } from "./models";

type ApiResponse = {
  message: string;
  result: Badge[];
  statusCode: number;
  statusName: string;
};

const GetBadgeChallenges = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GetBadgeChallenges: builder.query({
      providesTags: ["Challenges"],
      query: () => ({
        url: "",
        method: "GET",
        params: {
          Endpoint: "GetBadgeChallenges",
          UserId: secureStorage.get<string>(StorageKeys.USER_ID),
        }
      }),
      transformResponse: (response: ApiResponse) => response,
    }),
  }),
});

export const { useGetBadgeChallengesQuery } = GetBadgeChallenges;
